import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useOpenableControls } from '../../../../../../generic-hooks'
import { IconCircleInfoFilled } from '../../../../../../icons'

type ProductPageContactLensesInfoButtonProps = {
  variantAttribute: string
}

type DialogProps = {
  content: ReactNode
  title: ReactNode
}

const dialogPropsByVariantAttributeMap = new Map<string, DialogProps>([
  [
    'addition',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.addition.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.addition.info.headline" />
      ),
    },
  ],
  [
    'axis',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.axis.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.axis.info.headline" />
      ),
    },
  ],
  [
    'base_curve',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.baseCurve.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.baseCurve.info.headline" />
      ),
    },
  ],
  [
    'cylinder',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.cylinder.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.cylinder.info.headline" />
      ),
    },
  ],
  [
    'diameter',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.diameter.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.diameter.info.headline" />
      ),
    },
  ],
  [
    'sphere_power',
    {
      content: (
        <FormattedMessage id="variantAttributes.contactLens.dioptre.info.massage" />
      ),
      title: (
        <FormattedMessage id="variantAttributes.contactLens.dioptre.info.headline" />
      ),
    },
  ],
])

export const ProductPageContactLensesInfoButton: FC<
  ProductPageContactLensesInfoButtonProps
> = (props) => {
  const { variantAttribute } = props

  const { handleClose, handleOpen, isOpen } = useOpenableControls()

  const dialogContent = dialogPropsByVariantAttributeMap.get(variantAttribute)

  if (!dialogContent) {
    return null
  }

  const { content, title } = dialogContent

  return (
    <>
      <button
        className="align-middle focus-visible:outline-0"
        onClick={handleOpen}
        type="button"
      >
        <IconCircleInfoFilled className="size-5 fill-dark-brand hover:fill-dark-hover-brand active:fill-dark-pressed-brand" />
      </button>
      <Dialog onClose={handleClose} open={isOpen}>
        <DialogTitle onClose={handleClose}>{title}</DialogTitle>
        <DialogContent className="m-5 rounded-lg bg-light-primary-low text-dark-primary-strong">
          {content}
        </DialogContent>
      </Dialog>
    </>
  )
}
